/* eslint-disable max-len */
import React, { useEffect } from 'react'
import LottieAnimation from '../Animation/LottieAnimation'
import emptysearch from '../../helpers/emptysearch.json'

function SearchEmptyScreen({text,setSkip,isPatient,monitorPatientList,DeviceAlertList,deviceReadingHistory}) {
    useEffect(()=>{
        setSkip?setSkip(true):null
    },[])
    return (
        <div className={`flex flex-col justify-center items-center ${isPatient!==undefined?'h-[calc(100vh-540px)]': (monitorPatientList ? 'h-[calc(100vh-312px)]' : DeviceAlertList ? 'h-[calc(100vh-490px)]': deviceReadingHistory ? 'h-[calc(100vh-326px)]': 'h-customh5')} w-full`}>
            <div className='w-[320px] h-[280px] '>
                <LottieAnimation loop={true} animateFile={emptysearch} height="250" width="250"/> 
            </div>
            <p className='text-xl font-normal text-[#000]'>{text}</p>
        </div>
    )
}
export default SearchEmptyScreen;